/* Generated */ import { environment } from '../../environments/environment'; /* Generated *//* tslint:disable */
import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { ConditionalBehaviourRule, SeedDatabaseResponse, DecisionServiceVersionDescription, DecisionServiceVersionBusinessData, DecisionServiceVersionPairData, DecisionServiceVersionListData, BusinessDataProperty, DecisionServiceVersionListDataItem, Decision, OutputData, Form, Step, Text, Section, Question, ExecutionResult, ValueList, Pair, Variable, HitConclusion, ErrorMessage, ValueListItem, RootForm, PublishedForm, DecisionServiceVersion, ApiExecutionRequest, ExecutionRequestData, Object, Respond, RespondAnswer, Respondent, Questions, Template } from './models';
import 'rxjs/Rx';


@Injectable()
/**
 * Created with angular2-swagger-client-generator v
 */
export class ApiClientService {
	domain:string;
getIP() { return this.http.get('https://ipinfo.io').map((res: Response) => res.json()); }
  
  constructor(public http: Http){
    this.domain = environment.formsapi.url;
  }
  /*
	constructor(public http: Http, options?: any) {
		var domain = (typeof options === 'object') ? options.domain : options;
		this.domain = typeof(domain) === 'string' ? domain : '';
		
		if(this.domain.length === 0) {
			throw new Error('Domain parameter must be specified as a string.');
		}
		
	}
  */


	/**
  *
	* @method
	* @name ConditionalBehaviourRuleApi_Put
	* @param {ConditionalBehaviourRule} rule - 
	* 
	*/
	public ConditionalBehaviourRuleApi_Put(rule: ConditionalBehaviourRule) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['rule'] = rule;
		let uri = `/conditionalbehaviourrule`;
	  
		return this.http
			.put(this.domain + uri, JSON.stringify(rule), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name ConditionalBehaviourRuleApi_Post
	* @param {ConditionalBehaviourRule} rule - 
	* 
	*/
	public ConditionalBehaviourRuleApi_Post(rule: ConditionalBehaviourRule) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['rule'] = rule;
		let uri = `/conditionalbehaviourrule`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(rule), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name ConditionalBehaviourRuleApi_Delete
	* @param {integer} id - 
	* 
	*/
	public ConditionalBehaviourRuleApi_Delete(id: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/conditionalbehaviourrule/${id}`;
	  
		return this.http
			.delete(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name DatabaseManagement_MigrateDatabase
	* 
	*/
	public DatabaseManagement_MigrateDatabase() {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
		let uri = `/dbmgmt/migratedb`;
	  
		return this.http
			.post(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name DecisionApi_PostDecisionByVersion
	* @param {DecisionServiceVersionDescription} version - 
	* @param {integer} stepid - 
	* 
	*/
	public DecisionApi_PostDecisionByVersion(version: DecisionServiceVersionDescription, stepid: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['version'] = version;
			
		let uri = `/decisionsbyversion/${stepid}`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(version), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name DecisionApi_Put
	* @param {Decision} decision - 
	* 
	*/
	public DecisionApi_Put(decision: Decision) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['decision'] = decision;
		let uri = `/decisions`;
	  
		return this.http
			.put(this.domain + uri, JSON.stringify(decision), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name DecisionApi_Delete
	* @param {integer} id - 
	* 
	*/
	public DecisionApi_Delete(id: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/decisions/${id}`;
	  
		return this.http
			.delete(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_Put
	* @param {Form} form - 
	* 
	*/
	public FormApi_Put(form: Form) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['form'] = form;
		let uri = `/forms`;
	  
		return this.http
			.put(this.domain + uri, JSON.stringify(form), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_Post
	* @param {Form} form - 
	* 
	*/
	public FormApi_Post(form: Form) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['form'] = form;
		let uri = `/forms`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(form), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_Get
	* @param {integer} id - 
	* 
	*/
	public FormApi_Get(id: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/forms/${id}`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_GetByGuid
	* @param {string} guid - 
	* 
	*/
	public FormApi_GetByGuid(guid: string) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/forms/getbyguid/${guid}`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_GetByGuidAndVersion
	* @param {string} guid - 
	* @param {integer} version - 
	* 
	*/
	public FormApi_GetByGuidAndVersion(guid: string, version: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
			
		let uri = `/forms/getbyguidandversion/${guid}/${version}`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_GetAll
	* 
	*/
	public FormApi_GetAll() {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
		let uri = `/forms/list`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_CanIAccessForm
	* @param {integer} id - 
	* 
	*/
	public FormApi_CanIAccessForm(id: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/forms/caniaccessform/${id}`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_GetMyForms
	* 
	*/
	public FormApi_GetMyForms() {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
		let uri = `/forms/getmyforms`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_GetMyPublishedForms
	* 
	*/
	public FormApi_GetMyPublishedForms() {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
		let uri = `/forms/getmypublishedforms`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_GetAllDecisionServiceVersionDescriptions
	* @param {string} guid - 
	* 
	*/
	public FormApi_GetAllDecisionServiceVersionDescriptions(guid: string) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/forms/versions/${guid}`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_GetAllDecisionServiceVersions
	* @param {string} guid - 
	* 
	*/
	public FormApi_GetAllDecisionServiceVersions(guid: string) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/forms/simpleversions/${guid}`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_Execute
	* @param {ApiExecutionRequest} apiExecutionRequest - 
	* @param {string} guid - 
	* 
	*/
	public FormApi_Execute(apiExecutionRequest: ApiExecutionRequest, guid: string) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['apiExecutionRequest'] = apiExecutionRequest;
			
		let uri = `/forms/execute/${guid}`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(apiExecutionRequest), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_ConfirmPassword
	* @param {string} password - 
	* @param {string} guid - 
	* 
	*/
	public FormApi_ConfirmPassword(password: string, guid: string) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
			
		let uri = `/forms/enterform/${password}/${guid}`;
	  
		return this.http
			.post(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_OrderSteps
	* @param {Form} form - 
	* 
	*/
	public FormApi_OrderSteps(form: Form) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['form'] = form;
		let uri = `/forms/ordersteps`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(form), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_UpdateFormQuestions
	* @param {Form} form - 
	* 
	*/
	public FormApi_UpdateFormQuestions(form: Form) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['form'] = form;
		let uri = `/forms/updateformquestions`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(form), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_ChangeSummary
	* @param {integer} id - 
	* @param {boolean} summary - 
	* 
	*/
	public FormApi_ChangeSummary(id: number, summary: boolean) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
			
		let uri = `/forms/${id}/${summary}`;
	  
		return this.http
			.post(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_DownloadTemplate
	* @param {integer} id - 
	* 
	*/
	public FormApi_DownloadTemplate(id: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/forms/download/${id}`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_DownloadRespondents
	* @param {integer} id - 
	* @param {string} domain - 
	* @param {string} showheader - 
	* @param {string} showprevioussteps - 
	* @param {string} templateid - 
	* 
	*/
	public FormApi_DownloadRespondents(id: number, domain: string, showheader: string, showprevioussteps: string, templateid: string) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
			
			
			
			
		let uri = `/forms/downloadRespondents/${id}/${domain}/${showheader}/${showprevioussteps}/${templateid}`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_UploadPrefilledResponds
	* 
	*/
	public FormApi_UploadPrefilledResponds() {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
		let uri = `/upload`;
	  
		return this.http
			.post(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_UploadPrefilledRespondsPreview
	* 
	*/
	public FormApi_UploadPrefilledRespondsPreview() {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
		let uri = `/uploadpreview`;
	  
		return this.http
			.post(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_UpdateFormTexts
	* @param {Form} form - 
	* 
	*/
	public FormApi_UpdateFormTexts(form: Form) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['form'] = form;
		let uri = `/forms/updateformtexts`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(form), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_GetByRespondGuid
	* @param {string} guid - 
	* 
	*/
	public FormApi_GetByRespondGuid(guid: string) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/forms/getbyrespondguid/${guid}`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name FormApi_SendRespond
	* @param {Respondent} respondent - 
	* 
	*/
	public FormApi_SendRespond(respondent: Respondent) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['respondent'] = respondent;
		let uri = `/forms/sendrespond`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(respondent), { headers: headers, params: queryParameters })
			.map((res: Response) => {
				return res;
      });
	}
	
	/**
  *
	* @method
	* @name QuestionApi_Put
	* @param {Question} question - 
	* 
	*/
	public QuestionApi_Put(question: Question) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['question'] = question;
		let uri = `/questions`;
	  
		return this.http
			.put(this.domain + uri, JSON.stringify(question), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name QuestionApi_Post
	* @param {Question} question - 
	* 
	*/
	public QuestionApi_Post(question: Question) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['question'] = question;
		let uri = `/questions`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(question), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name QuestionApi_AddAllQuestionsFromDecision
	* @param {Questions} questions - 
	* 
	*/
	public QuestionApi_AddAllQuestionsFromDecision(questions: Questions) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['questions'] = questions;
		let uri = `/questions/addallquestionsfromdecision`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(questions), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name QuestionApi_Delete
	* @param {integer} id - 
	* 
	*/
	public QuestionApi_Delete(id: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/questions/${id}`;
	  
		return this.http
			.delete(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name RespondApi_GetByGuid
	* @param {string} guid - 
	* 
	*/
	public RespondApi_GetByGuid(guid: string) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/respond/${guid}`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name RespondApi_Put
	* @param {Respond} respond - 
	* 
	*/
	public RespondApi_Put(respond: Respond) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['respond'] = respond;
		let uri = `/respond`;
	  
		return this.http
			.put(this.domain + uri, JSON.stringify(respond), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name RespondApi_Post
	* @param {Respond} respond - 
	* 
	*/
	public RespondApi_Post(respond: Respond) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['respond'] = respond;
		let uri = `/respond`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(respond), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name RespondApi_Delete
	* @param {integer} id - 
	* 
	*/
	public RespondApi_Delete(id: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/respond/${id}`;
	  
		return this.http
			.delete(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name RespondApi_Execute
	* @param {ApiExecutionRequest} apiExecutionRequest - 
	* @param {string} guid - 
	* 
	*/
	public RespondApi_Execute(apiExecutionRequest: ApiExecutionRequest, guid: string) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['apiExecutionRequest'] = apiExecutionRequest;
			
		let uri = `/respond/execute/${guid}`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(apiExecutionRequest), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name RespondApi_ExportResponds
	* @param {integer} id - 
	* 
	*/
	public RespondApi_ExportResponds(id: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/respond/exportresponds/${id}`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name SectionApi_Put
	* @param {Section} section - 
	* 
	*/
	public SectionApi_Put(section: Section) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['section'] = section;
		let uri = `/sections`;
	  
		return this.http
			.put(this.domain + uri, JSON.stringify(section), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name SectionApi_Post
	* @param {Section} section - 
	* 
	*/
	public SectionApi_Post(section: Section) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['section'] = section;
		let uri = `/sections`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(section), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name SectionApi_Delete
	* @param {integer} id - 
	* 
	*/
	public SectionApi_Delete(id: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/sections/${id}`;
	  
		return this.http
			.delete(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name StepApi_Put
	* @param {Step} step - 
	* 
	*/
	public StepApi_Put(step: Step) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['step'] = step;
		let uri = `/steps`;
	  
		return this.http
			.put(this.domain + uri, JSON.stringify(step), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name StepApi_Post
	* @param {Step} step - 
	* 
	*/
	public StepApi_Post(step: Step) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['step'] = step;
		let uri = `/steps`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(step), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name StepApi_UpdateOrders
	* @param {Step} step - 
	* 
	*/
	public StepApi_UpdateOrders(step: Step) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['step'] = step;
		let uri = `/steps/updateorders`;
	  
		return this.http
			.put(this.domain + uri, JSON.stringify(step), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name StepApi_Delete
	* @param {integer} id - 
	* 
	*/
	public StepApi_Delete(id: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/steps/${id}`;
	  
		return this.http
			.delete(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name TemplateApi_UploadFile
	* 
	*/
	public TemplateApi_UploadFile() {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
		let uri = `/template/logo/upload`;
	  
		return this.http
			.post(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name TemplateApi_Put
	* @param {Template} template - 
	* 
	*/
	public TemplateApi_Put(template: Template) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['template'] = template;
		let uri = `/template`;
	  
		return this.http
			.put(this.domain + uri, JSON.stringify(template), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name TemplateApi_Post
	* @param {Template} template - 
	* 
	*/
	public TemplateApi_Post(template: Template) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['template'] = template;
		let uri = `/template`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(template), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name TemplateApi_Get
	* @param {integer} id - 
	* 
	*/
	public TemplateApi_Get(id: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/template/${id}`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name TemplateApi_Delete
	* @param {integer} id - 
	* 
	*/
	public TemplateApi_Delete(id: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/template/${id}`;
	  
		return this.http
			.delete(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name TemplateApi_GetAll
	* 
	*/
	public TemplateApi_GetAll() {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
		let uri = `/template/list`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name TemplateApi_GetMyOrganisations
	* 
	*/
	public TemplateApi_GetMyOrganisations() {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
		let uri = `/organisations`;
	  
		return this.http
			.get(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name TextApi_Put
	* @param {Text} text - 
	* 
	*/
	public TextApi_Put(text: Text) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['text'] = text;
		let uri = `/Text`;
	  
		return this.http
			.put(this.domain + uri, JSON.stringify(text), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name TextApi_Post
	* @param {Text} text - 
	* 
	*/
	public TextApi_Post(text: Text) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['text'] = text;
		let uri = `/Text`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(text), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name TextApi_Delete
	* @param {integer} id - 
	* 
	*/
	public TextApi_Delete(id: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/Text/${id}`;
	  
		return this.http
			.delete(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name VariableApi_Put
	* @param {Variable} variable - 
	* 
	*/
	public VariableApi_Put(variable: Variable) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['variable'] = variable;
		let uri = `/Variable`;
	  
		return this.http
			.put(this.domain + uri, JSON.stringify(variable), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name VariableApi_Post
	* @param {Variable} variable - 
	* 
	*/
	public VariableApi_Post(variable: Variable) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		payload['variable'] = variable;
		let uri = `/Variable`;
	  
		return this.http
			.post(this.domain + uri, JSON.stringify(variable), { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	
	/**
  *
	* @method
	* @name VariableApi_Delete
	* @param {integer} id - 
	* 
	*/
	public VariableApi_Delete(id: number) {
		let payload = {};	
		let queryParameters = {};
		let headers = new Headers();
		headers.append('Content-Type', 'application/json');
		
			
		let uri = `/Variable/${id}`;
	  
		return this.http
			.delete(this.domain + uri, { headers: headers, params: queryParameters })
			.map((res: Response) => {
        return res.json();
      });
	}
	

}




// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/index.ts